module.exports = __webpack_public_path__ + "static/media/fallas_leyenda.fe3130c3.png";